// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609080204/js/" + chunkId + "." + {"44":"7a1c3f4e","225":"e4d16a59","481":"bcf9b658","486":"67588733","770":"cd1e1a45"}[chunkId] + ".0.8038158737801376.chunk.js";
};